import BaseType from "../BaseType";
import EducatorLogItem from "./EducatorLogItem";

export default class EducatorLogHeader extends BaseType {
  Items: EducatorLogItem[] = [];
}
